import React, { useCallback, useEffect, useState, useRef } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
const testimonials = [{
  text: 'Recuperé el enfoque. Ya no salto de tarea en tarea.',
  initials: 'J.C.',
  role: 'Desarrollador Senior'
}, {
  text: 'El crash de las 4 PM desapareció. Llego lúcido al final del día.',
  initials: 'L.M.',
  role: 'Gerente de Ventas'
}, {
  text: 'Me volví más eficiente. Tomo decisiones estratégicas más rápido.',
  initials: 'R.B.',
  role: 'Emprendedora Serial'
}, {
  text: 'Siento la cabeza más liviana, sin ese atontamiento constante.',
  initials: 'M.A.',
  role: 'Arquitecta'
}, {
  text: 'Reduje el café a la mitad. La energía ahora es natural y estable.',
  initials: 'G.P.',
  role: 'Abogado'
}, {
  text: 'En solo 3 días noté la diferencia. Este manual es una inversión.',
  initials: 'F.D.',
  role: 'Consultor Financiero'
}, {
  text: 'Ideal para quienes exigimos mucho a nuestra mente diariamente.',
  initials: 'S.H.',
  role: 'Analista de Datos'
}];
export function SocialProofSection() {
  const [currentIndex, setCurrentIndex] = useState(1);
  const [isHovered, setIsHovered] = useState(false);
  const [cardsToShow, setCardsToShow] = useState(3);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  // Create an array with cloned items at both ends for seamless looping
  const extendedTestimonials = [testimonials[testimonials.length - 1], ...testimonials, testimonials[0], testimonials[1], testimonials[2]];
  // Handle responsive cards to show
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCardsToShow(1);
      } else if (window.innerWidth < 1024) {
        setCardsToShow(2);
      } else {
        setCardsToShow(3);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const nextSlide = useCallback(() => {
    setIsTransitioning(true);
    setCurrentIndex(prev => prev + 1);
  }, []);
  const prevSlide = () => {
    setIsTransitioning(true);
    setCurrentIndex(prev => prev - 1);
  };
  // Handle infinite loop reset after transition completes
  const handleTransitionEnd = () => {
    if (currentIndex === 0) {
      setIsTransitioning(false);
      setCurrentIndex(testimonials.length);
    } else if (currentIndex >= testimonials.length + 1) {
      setIsTransitioning(false);
      setCurrentIndex(1);
    }
  };
  // Autoplay
  useEffect(() => {
    if (isHovered) {
      if (timeoutRef.current) clearInterval(timeoutRef.current);
      return;
    }
    timeoutRef.current = setInterval(() => {
      nextSlide();
    }, 3000);
    return () => {
      if (timeoutRef.current) clearInterval(timeoutRef.current);
    };
  }, [isHovered, nextSlide]);
  return <section className="pt-6 pb-16 md:pt-8 md:pb-24 px-6 bg-background text-navy overflow-hidden relative" data-id="element-272">
      <div className="max-w-6xl mx-auto" data-id="element-273">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-10 md:mb-16 uppercase tracking-wider text-navy" data-id="element-274">
          Resultados reales en el mundo profesional
        </h2>

        <div className="relative px-4 md:px-12" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-275">
          {/* Carousel Container */}
          <div className="overflow-hidden" data-id="element-276">
            <div className={`flex ${isTransitioning ? 'transition-transform duration-500 ease-in-out' : ''}`} style={{
            transform: `translateX(-${currentIndex * (100 / cardsToShow)}%)`
          }} onTransitionEnd={handleTransitionEnd} data-id="element-277">
              {extendedTestimonials.map((testimonial, index) => <div key={index} className="w-full md:w-1/2 lg:w-1/3 flex-shrink-0 px-3" data-id="element-278">
                  <div className="bg-white p-8 rounded-xl border border-navy/5 h-full flex flex-col relative shadow-sm" data-id="element-279">
                    <Quote className="w-10 h-10 text-accent opacity-50 mb-4 rotate-180" data-id="element-280" />

                    <p className="text-navy/80 text-lg leading-relaxed flex-grow font-medium" data-id="element-281">
                      "{testimonial.text}"
                    </p>

                    <div className="border-t border-accent/10 mt-6 pt-4" data-id="element-282">
                      <p className="text-navy font-bold" data-id="element-283">
                        {testimonial.initials}
                      </p>
                      <p className="text-accent text-sm font-medium mt-0.5" data-id="element-284">
                        {testimonial.role}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white hover:bg-accent/5 border border-navy/10 rounded-full text-accent transition-colors z-10 shadow-sm" aria-label="Anterior" data-id="element-285">
            <ChevronLeft className="w-6 h-6" data-id="element-286" />
          </button>

          <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white hover:bg-accent/5 border border-navy/10 rounded-full text-accent transition-colors z-10 shadow-sm" aria-label="Siguiente" data-id="element-287">
            <ChevronRight className="w-6 h-6" data-id="element-288" />
          </button>
        </div>
      </div>
    </section>;
}